/**
 * AddElementsDropdown - Dropdown menu for adding various elements
 * 
 * Displays context-appropriate options for adding sections, steps, substeps,
 * attachments, canvas, forms, rich text, and videos based on the current context.
 * 
 * @param {Object} props
 * @param {boolean} props.isPart - Whether in part context
 * @param {boolean} props.isSection - Whether in section context
 * @param {boolean} props.isStep - Whether in step context
 * @param {boolean} props.isSubstep - Whether in substep context
 * @param {function} props.onItemClick - Callback when an item is clicked (type) => void
 */
const AddElementsDropdown = ({
  isPart,
  isSection,
  isStep,
  isSubstep,
  onItemClick,
}) => {
  const handleItemClick = (type) => {
    if (onItemClick) {
      onItemClick(type);
    }
    // TODO: Implement add element logic
  };

  /**
   * Renders a dropdown button for a specific element type
   * 
   * @param {string} type - The element type (e.g., "Section", "Step", "Canvas")
   * @param {boolean} isPartButton - Whether this is a part context button (different styling)
   */
  const renderDropdownButton = (type, isPartButton = false) => {
    const baseStyle = {
      padding: "8px 16px",
      width: "100%",
      textAlign: "left",
      border: "none",
      outline: "none",
      backgroundColor: "transparent",
    };

    const fullStyle = {
      ...baseStyle,
      cursor: "pointer",
      border: "none",
      backgroundColor: "transparent",
    };

    return (
      <button
        key={type}
        className={isPartButton ? undefined : "dropdown-item"}
        onClick={() => handleItemClick(type)}
        style={isPartButton ? baseStyle : fullStyle}
      >
        + {type}
      </button>
    );
  };

  /**
   * Gets the list of available element types based on current context
   */
  const getElementTypes = () => {
    if (isPart) {
      return { items: ["Section"], isPartButton: true };
    } else if (isSubstep) {
      return {
        items: ["Substep", "Attachment", "Canvas", "Form", "Rich Text", "Video"],
        isPartButton: false,
      };
    } else if (isStep) {
      return {
        items: ["Step", "Substep", "Attachment", "Canvas", "Form", "Rich Text", "Video"],
        isPartButton: false,
      };
    } else if (isSection) {
      return { items: ["Section", "Step"], isPartButton: false };
    } else {
      return {
        items: ["Attachment", "Canvas", "Form", "Rich Text", "Video"],
        isPartButton: false,
      };
    }
  };

  const { items, isPartButton } = getElementTypes();

  return (
    <div
      className="dropdown-menu"
      style={{
        position: "absolute",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
        padding: "10px",
        borderRadius: "5px",
        marginTop: "5px",
        left: "0",
      }}
    >
      {items.map((type) => renderDropdownButton(type, isPartButton))}
    </div>
  );
};

export default AddElementsDropdown;

